import { apiClient } from './apiClient';

export const providerService = {
    getProviders: async () => {
        const res = await apiClient.get('/providers');
        return res.data;
    },

    createProvider: async (data) => {
        const res = await apiClient.post('/providers', data);
        return res.data;
    },

    updateProvider: async (id, data) => {
        const res = await apiClient.put(`/providers/${id}`, data);
        return res.data;
    },

    toggleActive: async (id) => {
        const res = await apiClient.patch(`/providers/${id}/toggle-active`);
        return res.data;
    },

    deleteProvider: async (id) => {
        await apiClient.delete(`/providers/${id}`);
    },

    registerWebhook: async (id, url) => {
        const res = await apiClient.post(`/providers/${id}/webhook`, { endpoint: url });
        return res.data;
    },

    deleteWebhook: async (id) => {
        const res = await apiClient.delete(`/providers/${id}/webhook`);
        return res.data;
    },
};
